"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DimensionUnitShortLabels = exports.DimensionUnitLabels = exports.DimensionUnit = exports.DimensionUnits = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.DimensionUnits = ['INCHES', 'FEET', 'METERS'];
exports.DimensionUnit = typebox_1.Type.Union(exports.DimensionUnits.map((type) => typebox_1.Type.Literal(type)));
exports.DimensionUnitLabels = {
    INCHES: 'Inches',
    FEET: 'Feet',
    METERS: 'Meters',
};
exports.DimensionUnitShortLabels = {
    INCHES: 'in',
    FEET: 'ft',
    METERS: 'm',
};
//# sourceMappingURL=dimension-unit.js.map